import React from "react";
import { Navigate } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
 const token = sessionStorage.getItem("token");

  if (!token) {
    // ❌ Sem token → manda pro login
    return <Navigate to="/" replace />;
  }

  // ✅ Token existe → mostra o conteúdo da rota
  return children;
};

export default ProtectedRoute;
